// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"6b0f96ca","147":"9c157c33","362":"3475eeaa","415":"54ed709c","615":"c3181b91","807":"93777a9e","818":"4dcdf2a6","899":"9d763846","900":"38b7f7dd"}[chunkId] + ".chunk.js";
};